document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-hero]').forEach((hero) => {
    const track = hero.querySelector('[data-track]');
    const slides = [...hero.querySelectorAll('[data-slide]')];
    const dots = [...hero.querySelectorAll('[data-dot]')];
    if (!track || !slides.length) return;

    let index = 0;
    const go = (next) => {
      index = (next + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((dot, dotIndex) => dot.classList.toggle('active', dotIndex === index));
    };

    hero.querySelector('[data-prev]')?.addEventListener('click', () => go(index - 1));
    hero.querySelector('[data-next]')?.addEventListener('click', () => go(index + 1));
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => go(dotIndex)));
    go(0);

    if (slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setInterval(() => go(index + 1), 6500);
    }
  });

  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    const header = button.closest('[data-header]');
    const menu = header?.querySelector('[data-mobile-nav]');
    if (!menu) return;

    button.addEventListener('click', () => {
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      button.setAttribute('aria-label', isOpen ? 'Open menu' : 'Close menu');
      button.textContent = isOpen ? '☰' : '×';
      menu.hidden = isOpen;
    });
  });

  document.querySelectorAll('[data-countdown]').forEach((section) => {
    const target = Date.parse(section.dataset.countdown || '');
    const clock = section.querySelector('.countdown__clock');
    if (!clock || Number.isNaN(target)) return;

    const fields = {
      days: section.querySelector('[data-days]'),
      hours: section.querySelector('[data-hours]'),
      minutes: section.querySelector('[data-minutes]'),
      seconds: section.querySelector('[data-seconds]')
    };

    const render = () => {
      const remaining = target - Date.now();
      if (remaining <= 0) {
        clock.innerHTML = `<strong class="countdown__live">${section.dataset.expiredMessage || 'THE DROP IS LIVE!'}</strong>`;
        return false;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      fields.days.textContent = String(Math.floor(totalSeconds / 86400)).padStart(2, '0');
      fields.hours.textContent = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(2, '0');
      fields.minutes.textContent = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
      fields.seconds.textContent = String(totalSeconds % 60).padStart(2, '0');
      return true;
    };

    if (render()) {
      const timer = setInterval(() => {
        if (!render()) clearInterval(timer);
      }, 1000);
    }
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('.product-gallery__main-image');
    const thumbs = [...gallery.querySelectorAll('[data-product-thumb]')];
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const imageUrl = thumb.getAttribute('data-image-url');
        const imageSrcset = thumb.getAttribute('data-image-srcset');
        const imageAlt = thumb.getAttribute('data-image-alt') || '';
        if (imageUrl) mainImage.src = imageUrl;
        if (imageSrcset) mainImage.srcset = imageSrcset;
        mainImage.alt = imageAlt;
        thumbs.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-welcome-popup]').forEach((popup) => {
    const storageKey = 'sbl-welcome-popup-dismissed';
    const closeButtons = [...popup.querySelectorAll('[data-popup-close]')];
    const copyButton = popup.querySelector('[data-copy-code]');
    const code = popup.dataset.discountCode || 'WELCOME10';

    const closePopup = () => {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      try { window.localStorage.setItem(storageKey, 'true'); } catch (error) {}
    };

    let dismissed = false;
    try { dismissed = window.localStorage.getItem(storageKey) === 'true'; } catch (error) {}
    if (!dismissed) {
      window.setTimeout(() => {
        popup.classList.add('is-visible');
        popup.setAttribute('aria-hidden', 'false');
        popup.querySelector('.welcome-popup__close')?.focus();
      }, 1400);
    }

    closeButtons.forEach((button) => button.addEventListener('click', closePopup));
    popup.addEventListener('click', (event) => {
      if (event.target === popup) closePopup();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && popup.classList.contains('is-visible')) closePopup();
    });

    copyButton?.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(code);
        copyButton.textContent = 'COPIED!';
      } catch (error) {
        copyButton.textContent = code;
      }
    });
  });

  document.querySelectorAll('[data-social-feed]').forEach((feed) => {
    const videos = [...feed.querySelectorAll('.social-post video')];
    if (!videos.length || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play().catch(() => {});
        } else {
          entry.target.pause();
        }
      });
    }, { threshold: 0.35 });

    videos.forEach((video) => observer.observe(video));
  });
});
